
import { BaseModel } from '../abstracts/base.model'

export class StudentModel extends BaseModel {
  StudentID: string
  TCIdentityNumber: string
  StudentNumber: string
  StudentSchoolNumber: string
  StudentSchool: string
  FirstName: string
  LastName: string
  ClassLevelID: string
  ClassLevel: string
  AlanID: string
  Birthday: Date
  BirthPlace: string
  GenderID: number
  PhoneNumber: string
  AddressID: string
  ParentID: string
  MotherFirstName: string
  MotherLastName: string
  MotherPhoneNumber: string
  FatherFirstName: string
  FatherLastName: string
  UserID: number
  FullName:string
  CompanyID: string
  StudentDepartment: string
  StudentClassName: string

  UserIsActive: boolean
  UserPhoto: string
  CompanyPhoto: string
  Email: string
  ClassName: string
  Alan: string
  ParentName: string
  CompanyName: string
  ParentPhoneNumber: string
  PaidTotal: number = 0
  Total: number = 0
  IsManager: boolean;
}